import { createContext, useContext } from "react";
import type { Editor } from "@tiptap/react";
import type { ChatProps } from "./ChatProps.types";

export interface TipTapEditorContext {
  addMessageAttachments: any;
  addToLocalSgidToObjectMap: any;
  attachments: any;
  chatProps: ChatProps;
  chatRoomAccessArr: any[];
  editedAt?: string;
  editor: Editor;
  isUpdate: boolean;
  isWorkflowType: boolean;
  linkPreviews: { [key: string]: boolean } | undefined;
  localAttachments: any;
  localSgidToObjectMap: any;
  messageAttachments: any;
  portalTargetId?: string | null;
  removeMessageAttachments: any;
  setLinkPreviews: (linkPreviews: { [key: string]: boolean }) => void;
  setLocalAttachments: (attachments: any[]) => void;
  setShouldShowPrivateMessageConfirmationOnSubmit: (value: boolean) => void;
  sgidToObjectMap: any;
  shouldRefetch?: boolean;
  shouldScrollIntoView?: boolean;
  spaceId?: number;
  type: string;
}

export const TipTapEditorContext = createContext<TipTapEditorContext | null>(
  null,
);

TipTapEditorContext.displayName = "TipTapEditorContext";

// TODO: Remove `any` and type guard everywhere against null
export const useTipTapEditorContext = (): any =>
  useContext(TipTapEditorContext);
